const colors = [
  '#dc2626', // red-600
  '#ea580c', // orange-600
  '#ca8a04', // yellow-600
  '#65a30d', // lime-600
  '#16a34a' // green-600
];

export const getBarColor = (index: number): string => {
  return colors[index] ?? colors[colors.length - 1];
};
